import type { FeatureFlag } from '@forgd/shared/feature-flags'

const featureFlag: FeatureFlag = 'forgd-ai-chat'

export default defineNuxtRouteMiddleware(async () => {
  if (import.meta.server) {
    return
  }

  const auth = useAuth()

  await auth.waitForAuth({ from: 'ai-chat-enabled middleware' })
  await auth.ensureFlagsLoaded()

  if (!auth.featureFlags.includes(featureFlag)) {
    return abortNavigation(createError({ statusCode: 404, statusMessage: 'Page not found' }))
  }
})
